import React, { useEffect, useState } from 'react';

interface IProps {
    data: any;
    column: any;
    cellRenderSwitcher: (p: any, column: any, rowParent?: any) => Promise<React.ReactNode>;
}

const ViewCellRenderSwitcher: React.FC<IProps> = ({ data, column, cellRenderSwitcher }) => {
    const activated = React.useRef(false);
    const [comp, setComp] = useState<React.ReactNode>(undefined);

    useEffect(() => {
        activated.current = true;

        cellRenderSwitcher(data, column).then((value) => {
            if (activated.current) {
                setComp(value);
            }
        });

        return () => {
            activated.current = false;
        };
    }, []);

    return comp ?? <></>;
};

export default ViewCellRenderSwitcher;
